// ResourceSection
//
// Seccion de la pagina Formacion. Encapsula una Card con titulo, boton
// primary de "Nuevo" (opcional), grid de ResourceCard, estados
// loading/empty/error y paginacion. Se usa para Videos y para PDFs, en las
// dos verticales.

import React from "react";
import {
  Card,
  Row,
  Col,
  Skeleton,
  Empty,
  Pagination,
  Button,
  Alert,
} from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { ResourceCard } from "./ResourceCard";
import styles from "./ResourceSection.module.scss";

export function ResourceSection({
  title,
  icon,
  resources,
  loading,
  error,
  total,
  page,
  pageSize,
  onPageChange,
  onCreate,
  onEdit,
  onDelete,
  ctaLabel = "Nuevo",
  audienceOptions = [],
  emptyText = "Aun no hay recursos en esta seccion",
}) {
  return (
    <Card
      title={
        <span className={styles.title}>
          {icon}
          {title}
          {total !== undefined ? (
            <span className={styles.count}>({total})</span>
          ) : null}
        </span>
      }
      extra={
        onCreate ? (
          <Button type="primary" icon={<PlusOutlined />} onClick={onCreate}>
            {ctaLabel}
          </Button>
        ) : null
      }
      className={styles.section}
    >
      {error ? (
        <Alert
          type="error"
          showIcon
          message="No se pudo cargar"
          description={error}
        />
      ) : null}

      {loading ? (
        <Row gutter={[16, 16]}>
          {Array.from({ length: 4 }).map((_, i) => (
            // eslint-disable-next-line react/no-array-index-key
            <Col key={`sk-${i}`} xs={24} sm={12} md={8} lg={6}>
              <div className={styles.skeleton}>
                <Skeleton.Image style={{ width: "100%", height: 150 }} active />
                <div style={{ padding: 12 }}>
                  <Skeleton active paragraph={{ rows: 1 }} />
                </div>
              </div>
            </Col>
          ))}
        </Row>
      ) : null}

      {!loading && resources && resources.length === 0 ? (
        <Empty description={emptyText} />
      ) : null}

      {!loading && resources && resources.length > 0 ? (
        <>
          <Row gutter={[16, 16]}>
            {resources.map((r) => (
              <Col key={r._id} xs={24} sm={12} md={8} lg={6}>
                <ResourceCard
                  resource={r}
                  onEdit={onEdit}
                  onDelete={onDelete}
                  audienceOptions={audienceOptions}
                />
              </Col>
            ))}
          </Row>

          {total > pageSize ? (
            <div className={styles.pagination}>
              <Pagination
                current={page}
                total={total}
                pageSize={pageSize}
                onChange={onPageChange}
                showSizeChanger={false}
                showTotal={(t) => `${t} recursos en total`}
              />
            </div>
          ) : null}
        </>
      ) : null}
    </Card>
  );
}
